import axios from 'axios';
import { net_api_url } from 'components/Store';
const callCollectList = async (contentType, token, keywordListId, url) => {
  try {
    const source = new AbortController();
    let requestProperties = {
      eventName: keywordListId === null ? 'MasterTopicView' : 'TopicView',
      contentType: contentType,
      url: `${window.location.origin}${url}`,
    };
    if (keywordListId !== null) {
      requestProperties = { ...requestProperties, keywordListId: keywordListId };
    }

    let contentRelated = await axios.post(`${net_api_url}/api/log/collect`, requestProperties, {
      signal: source?.signal,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return contentRelated.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

export default callCollectList;
